module.exports = __webpack_public_path__ + "static/img/C4D0002.33525ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intru/C4D0002.jpg
// module id = 2i1t
// module chunks = 0